import React from 'react';

import ReactDOM from 'react-dom';
// Libs
import router from '../../lib/router.js';

import events from '../../lib/events.js';

import qwest from 'qwest';

import Loader from '../components/loader.jsx';
// Register in router
let render = (container) => {
  console.info('[UI.page.signOut] rendering page');
  ReactDOM.render(<PageSignOut />, container);
  events.publish('page-change', {page: 'signOut'});
};

console.info('[UI.page.signOut] register route');
router.rr.add([{path: 'signOut', handler: render}]);

// Page object
class PageSignOut extends React.Component {
  componentDidMount() {
    qwest.get('/Login/Logout')
      .then((xhr, res) => {
        if (res && res.path) {
          setTimeout(() => {
            window.location = res.path;
          }, 500);
        }
      });
  }

  render() {
    return (
      <div id='page-sign-out'>
        <Loader loaded={false} />
      </div>
    );
  }
}

export default PageSignOut;
